<div class="container-fluid" [dir]="dir">
  <div class="row m-row">
    <div class="col-lg-6 p-3 slider-container">
      <div class="right-panel">
        <div class="right-panel-head p-3">
          <div class="dropdown">
            <button
              class="btn btn-default dropdown-toggle lang-dropdown"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {{ currentLanguage === 'ar' ? 'العربية' : 'English' }}
            </button>
            <div class="dropdown-menu">
              <a class="dropdown-item" (click)="changeLanguage('en-US')"
                >English</a
              >
              <a class="dropdown-item" (click)="changeLanguage('ar')"
                >العربية</a
              >
            </div>
          </div>
        </div>
        <app-splash-screen-sliders
          [isWhiteBackground]="false"
        ></app-splash-screen-sliders>
      </div>
    </div>

    <div class="col-lg-6 main-content">
      <div class="main-header">
        <div class="d-flex justify-content-between">
          <div class="contact-div mt-3 pt-2" *ngIf="contactInfo" [dir]="dir">
            <button mat-stroked-button [matMenuTriggerFor]="userMenu">
              <mat-icon fontSet="material-icons-outlined" class="text-secondary"
                >help</mat-icon
              >
              <span translate class="text-secondary">Contact Us</span>
            </button>
            <mat-menu #userMenu="matMenu">
              <a
                mat-menu-item
                href="tel:{{ contactInfo.supportNumber | numberTranslate }}"
                class="text-left"
                dir="ltr"
              >
                <mat-icon>phone</mat-icon>
                <span dir="ltr">{{
                  contactInfo.supportNumber | numberTranslate
                }}</span>
              </a>
              <a
                mat-menu-item
                href="mailto:{{ contactInfo.supportEmail }}"
                class="text-left"
                dir="ltr"
              >
                <mat-icon>email</mat-icon>
                {{ contactInfo.supportEmail }}
              </a>
            </mat-menu>
          </div>
          <div class="language-div mt-3 pt-2">
            <app-language-selector [icon]="true"></app-language-selector>
          </div>
        </div>
      </div>

      <div class="form-div">
        <div class="text-center">
          <img
            class="logo-img"
            [src]="'assets/flyplus/app-logo.svg' | assets"
            alt=""
          />
        </div>

        <!-- Step 1: Enter email -->
        <ng-container *ngIf="step === 1">
          <div class="mt-5 text-center">
            <h5 class="fw-700" translate>account.reactivate.title</h5>
            <p class="sub-label" translate>account.reactivate.emailSubtitle</p>
          </div>

          <form [formGroup]="emailForm" class="d-flex flex-column">
            <mat-label translate>Email Address</mat-label>
            <mat-form-field
              [hideRequiredMarker]="true"
              appearance="outline"
              class="w-100"
            >
              <input
                type="email"
                matInput
                formControlName="email"
                [placeholder]="'Email Address' | translate"
                required
              />
              <mat-error *ngIf="emailForm.controls.email.invalid">
                <span translate>Email is required</span>
              </mat-error>
            </mat-form-field>

            <button
              class="align-self-stretch"
              color="primary"
              mat-flat-button
              [disabled]="loading.sending || emailForm.invalid"
              (click)="proceed()"
            >
              <span translate>account.reactivate.proceed</span>
              <app-loader
                class="d-inline-flex"
                [isLoading]="loading.sending"
              ></app-loader>
            </button>
          </form>

          <div class="text-center fs-13 fw-400 my-3">
            <span translate>Don't have an account?</span>
            <a href="/register" translate>Sign up</a>
          </div>
        </ng-container>

        <!-- Step 2: Verify OTP -->
        <ng-container *ngIf="step === 2">
          <div class="mt-5 text-center">
            <h5 class="fw-700" translate>account.reactivate.verifyTitle</h5>
            <p class="sub-label">
              {{ 'account.reactivate.otpSentTo' | translate }}
              <strong>{{ emailForm.get('email').value }}</strong>
            </p>
          </div>

          <div class="d-flex flex-column align-items-center">
            <ng-otp-input
              class="text-center"
              [formCtrl]="otpControl"
              [config]="otpConfig"
              dir="ltr"
            ></ng-otp-input>

            <div class="forgot-password my-3 text-secondary text-center">
              <div translate>Didn't receive the OTP yet?</div>
              <span *ngIf="isTimerActive" class="fw-600">
                <span translate>Resend OTP in </span>
                {{ getTimerText(timer) | numberTranslate }}
              </span>
              <a
                class="resend-otp-link c-pointer"
                *ngIf="!isTimerActive && !loading.sending"
                (click)="resend()"
                translate
                >Resend OTP?</a
              >
            </div>

            <button
              class="align-self-stretch"
              color="primary"
              mat-flat-button
              [disabled]="loading.verifying || otpControl.value?.length < 6"
              (click)="verify()"
            >
              <span translate>account.reactivate.verify</span>
              <app-loader
                class="d-inline-flex"
                [isLoading]="loading.verifying"
              ></app-loader>
            </button>
          </div>
        </ng-container>

        <div class="mt-5 text-center">
          <img
            [src]="'assets/flyplus/powered-by.png' | assets"
            width="130"
            class="mt-5 mb-3"
          />
        </div>
      </div>
    </div>
  </div>
</div>
